var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_64725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0.899973C8.56837 0.899973 0.900007 8.56834 0.900008 18C0.900008 27.4316 8.56837 35.1 18 35.1C27.4316 35.1 35.1 27.4316 35.1 18C35.1 8.56833 27.4316 0.899972 18 0.899973ZM18 31.8967C10.3316 31.8967 4.10329 25.6683 4.10329 18C4.10329 10.3316 10.3316 4.10325 18 4.10325C25.6684 4.10325 31.8967 10.3316 31.8967 18C31.8967 25.6683 25.6684 31.8967 18 31.8967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2999 10.2966C11.016 9.58049 12.177 9.58049 12.8931 10.2966L25.6443 23.0478C26.3604 23.7639 26.3604 24.9249 25.6443 25.6409C24.9283 26.357 23.7673 26.357 23.0512 25.6409L10.2999 12.8897C9.58387 12.1736 9.58387 11.0126 10.2999 10.2966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7285 10.2966C25.0124 9.58049 23.8515 9.58049 23.1354 10.2966L10.3841 23.0478C9.66805 23.7639 9.66805 24.9249 10.3841 25.6409C11.1002 26.357 12.2612 26.357 12.9772 25.6409L25.7285 12.8897C26.4446 12.1736 26.4446 11.0126 25.7285 10.2966Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_64725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(36 36) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoClose);
export default __webpack_public_path__ + "static/media/icon-info-close.5f021f44d906985c2ea41e04e3328c22.svg";
export { ForwardRef as ReactComponent };